import { getAuthHeaders } from "@/api/auth"
import axiosAuthRequired from "@/api/axiosAuthRequired"

export const getSessionHistoryPage = async (page) => {
  try {
    const response = await axiosAuthRequired({
      method: "get",
      url: process.env.PROGUIDES_WEB_URL + "api/v2/instapro/user/coach/session-history?page=" + page,
      headers: getAuthHeaders(),
    })
    return response.data
  } catch (e) {
    return Promise.reject(e)
  }
}



// WEBPACK FOOTER //
// ./src/api/user/coaching/sessionHistory.js